import { createStyles, makeStyles } from '@material-ui/styles'
import { Theme } from '@material-ui/core'
import { fontWeights } from '../../../shared/style/fonts'
import colors from '../../../shared/style/colors'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      padding: '2rem 2rem 2rem',
      display: 'flex',
      flexDirection: 'column',

      [theme.breakpoints.down('md')]: {
        flexDirection: 'column'
      },

      [theme.breakpoints.down('sm')]: {
        width: '100vw'
      },

      [theme.breakpoints.down('xs')]: {
        margin: '1rem 0 0 0',
        minHeight: '100vh',
        minWidth: '100vw'
      },

      '& button': {
        marginTop: '1rem',
        [theme.breakpoints.down('sm')]: {
          width: '100%'
        }
      }
    },
    modalTitle: {
      width: '100%',
      marginTop: '2rem'
    },
    closeButton: {
      zIndex: 1000,
      position: 'absolute',
      left: 0,
      top: 0,
      '&:focus': {
        outline: 'none'
      },

      [theme.breakpoints.down('xs')]: {
        top: 30
      }
    },
    title: {
      whiteSpace: 'normal',
      textAlign: 'center',
      color: colors.black,
      textTransform: 'none',
      fontSize: '2rem',
      margin: '0 auto 2rem auto',

      [theme.breakpoints.down('sm')]: {
        fontSize: '1.3rem'
      }
    },
    input: {
      margin: '.5rem 0 1rem 0',

      '& > p': {
        margin: '.3rem 0 0 0'
      },

      [theme.breakpoints.down('sm')]: {
        width: '100%'
      }
    },
    inputLabel: {
      color: colors.mainFont,
      fontWeight: fontWeights.weight_500
    },
    newsletterForm: {
      width: '70%',
      [theme.breakpoints.down('md')]: {
        width: '100%'
      }
    },
    button: {
      borderRadius: '8px',
      padding: '12px 60px',
      backgroundColor: 'transparent',
      textDecoration: 'none',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: fontWeights.weight_500,
      width: '70%',
      margin: '0 0 .5rem 0',

      '& > span': {
        fontWeight: fontWeights.weight_500
      },

      '&:focus': {
        outline: 'none'
      }
    },
    subscribeButton: {
      borderRadius: '8px',
      padding: '12px 60px',
      border: 'none',
      backgroundColor: colors.primary,
      textDecoration: 'none',
      color: colors.white,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: fontWeights.weight_500,
      width: '100%',
      margin: '0 0 .5rem 0',

      '&:hover': {
        textDecoration: 'none',
        backgroundColor: colors.primary
      },

      '& > span': {
        fontWeight: fontWeights.weight_500
      },

      '&:focus': {
        outline: 'none'
      },

      '&:disabled': {
        backgroundColor: colors.darkGrey
      },

      [theme.breakpoints.down('xs')]: {
        padding: `12px`
      }
    },
    legalMentions: {
      color: colors.light,
      fontSize: '10px',
      width: '100%'
    },
    link: {
      textDecoration: 'none',
      color: colors.primary,

      '&:hover': {
        textDecoration: 'underline'
      }
    },
    paper: {
      display: 'flex',
      alignItems: 'center',
      width: '50vw',

      [theme.breakpoints.up('md')]: {
        borderRadius: 16
      },

      [theme.breakpoints.down('md')]: {
        width: '70vw'
      },

      [theme.breakpoints.down('sm')]: {
        width: '100vw',
        height: '100vh'
      }
    },
    afterFormRegistration: {
      whiteSpace: 'pre-line',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      textAlign: 'center',
      margin: '0 0 0 0',

      '& > h1': {
        margin: '0 0 2rem 0'
      },

      '& > p': {
        fontWeight: fontWeights.weight_500,
        fontSize: '18px'
      }
    },
    loader: {
      color: colors.primary
    },
    thanksTitle: {
      color: colors.primary,
      fontSize: '3rem'
    },
    blocWrapper: {
      width: '100%',
      textAlign: 'center',
      paddingTop: '5rem'
    }
  })
)
